import React, { useEffect, useRef, useState } from "react";
import BannerHeader from "../../Components/BannerHeader/BannerHeader";
import SearchComponent from "./SearchComponent/SearchComponent";
import Sidebar from "./Sidebar/Sidebar";
import Card from "./Card/Card2";
import Footer from "../Footer/Footer";
import classes from "./BestSeller.module.css";
import {
  fetchBook,
  fetchBookCount,
  getFacets,
} from "../../Store/actions/BestSellerBookAction";
import { useDispatch, useSelector } from "react-redux";
import PrimaryNav from "../Header/PrimaryNav/PrimaryNav";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { urls } from "../../Routes/Urls";
import { getRandomImageForBestSellerBook, removeUnpairedQuotes } from "../../Util";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import useScrollToTop from "../../Hooks/useScrollToTop";
import SEO from "../../Components/SEO";

const itemsPerPage = 16;
const allGenres = [
  { name: "Special Edition", value: "Special Edition" },
  { name: "History & Ancient Records", value: "History & Ancient Records" },
  { name: "Classics & Literature", value: "Classics & Literature" },
  { name: "Religion", value: "Religion" },
  { name: "Music/Arts & Design", value: "Music/Arts & Design" },
  { name: "Education & Studies", value: "Education & Studies" },
  { name: "Spirituality", value: "Spirituality" },
  { name: "Politics & Sociology", value: "Politics & Sociology" },
  { name: "Philosophy & Ethics", value: "Philosophy & Ethics" },
  { name: "Adventure", value: "Adventure" },
  { name: "Mystery", value: "Mystery" },
  { name: "Thriller", value: "Thriller" },
  { name: "Self-Help", value: "Self-Help" },
  { name: "Fantasy", value: "Fantasy" },
  { name: "Domestic & Cultural Fiction", value: "Domestic & Cultural Fiction" },
  { name: "Sci-Fi", value: "Sci-Fi" },
  { name: "Health Science", value: "Health Science" },
  { name: "Horror", value: "Horror" },
  { name: "Technology & Applied Sciences", value: "Technology & Applied Sciences" },
  { name: "Biography & Memoirs", value: "Biography & Memoirs" },
  { name: "Home & Garden", value: "Home & Garden" },
  { name: "Young Adult", value: "Young Adult" },
  { name: "Children", value: "Children" },
  { name: "Romance", value: "Romance" },
  { name: "Business & Management", value: "Business & Management" },
  { name: "New Age", value: "New Age" },
  { name: "Law & Legal Studies", value: "Law & Legal Studies" },
  { name: "Occult & Supernatural", value: "Occult & Supernatural" },
  { name: "Yoga & Fitness", value: "Yoga & Fitness" },
  { name: "Languages & Linguistics", value: "Languages & Linguistics" },
  { name: "Environmental Studies", value: "Environmental Studies" },
  { name: "Games & Hobbies", value: "Games & Hobbies" },
  { name: "Sports", value: "Sports" },
  { name: "Other", value: "Other" },
  { name: "Science & Nature", value: "Science & Nature" },
  { name: "War & Combat", value: "War & Combat" },
  { name: "Language & Linguistics", value: "Language & Linguistics" }
];


const BestSeller = () => {
  const dispatch = useDispatch();
  const allColorsData = useSelector((state) => state.bookColor.colors);
  const wishlist = useSelector((state) => state.wishlist.wishlistItems);
  const location = useLocation();
  const history = useHistory();
  
  const [searchResults, setSearchResults] = useState([]);
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchCriteria,setSearchCriteria] = useState("all");
  const [query, setQuery] = useState(location.state?.query || "");
  const [sortBy, setSortBy] = useState("lastUpdated ASC");
  const [allowedMinPublishingYear, setAllowedMinPublishingYear] =
    useState(null);
  const [allowedMaxPublishingYear, setAllowedMaxPublishingYear] =
    useState(null);
  const [minPublishingYear, setMinPublishingYear] = useState(null);
  const [maxPublishingYear, setMaxPublishingYear] = useState(null);
  const [selectedGenres, setSelectedGenres] = useState([]);
  const [loading, setLoading] = useState(false); // Loading state
  const totalPages = totalResults > 0 ? Math.ceil(totalResults / itemsPerPage) : 1;
  const [isPageChange, setIsPageChange] = useState(false);

  const scrollRef = useScrollToTop();


  const getFilter = () => {
    const currPage = isPageChange ? currentPage : 1;
    let filter = {
      limit: itemsPerPage,
      offset: (currPage - 1) * itemsPerPage,
      where: {
        $and: [],
      },
    };

    if (query) {
      // Add field and query conditions
        // let updatedQuery = removeUnpairedQuotes(query);
        let updatedQuery = query
        updatedQuery = `"${updatedQuery}"`
      if (searchCriteria !== "all") {
        filter.where.$and.push({ [searchCriteria]: updatedQuery });
      } else {
        filter.where.$and.push({
          $or: [
            { author:updatedQuery },
            { title: updatedQuery },
            { language: updatedQuery},
            { sku: updatedQuery },
            { isbnNo: updatedQuery},
          ],
        });
      }
    }

    // Add publishingYear range condition in the format "MIN TO MAX"
    if (
      (minPublishingYear || maxPublishingYear) &&
      !(
        minPublishingYear === allowedMinPublishingYear &&
        maxPublishingYear === allowedMaxPublishingYear
      )
    ) {
      const publishingYearCondition = {
        publishingYear: `[${
          minPublishingYear === allowedMinPublishingYear
            ? "*"
            : minPublishingYear || "*"
        } TO ${
          maxPublishingYear === allowedMaxPublishingYear
            ? "*"
            : maxPublishingYear || "*"
        }]`,
      };
      filter.where.$and.push(publishingYearCondition);
    }

    if (selectedGenres?.length > 0) {
      filter.where.$and.push({ genres: selectedGenres.join(",") });
    }

    // Add sorting if provided
    if (sortBy) {
      filter.sortBy = sortBy;
    }

    return filter;
  };

  const fetchPageData = async () => {
    setLoading(true);
    const filter = getFilter();
    try {
      // Fetch books based on criteria, query, and pagination
      const data = await fetchBook(dispatch, filter);
      const total = await fetchBookCount(
        searchCriteria,
        query,
        minPublishingYear === allowedMinPublishingYear
          ? null
          : minPublishingYear,
        maxPublishingYear === allowedMaxPublishingYear
          ? null
          : maxPublishingYear,
        selectedGenres
      ); // Fetch total count
      setSearchResults(data.data);
      if (totalResults !== total) {
        setCurrentPage(1);
      }
      setTotalResults(total);
      setIsPageChange(false);
    } finally {
      setLoading(false);
    }
  };

  // Fetch facet data (like publishing year)
  useEffect(() => {
    getFacets().then((data) => {
      setMaxPublishingYear(data?.publishingYear?.max);
      setAllowedMaxPublishingYear(data?.publishingYear?.max);
      setMinPublishingYear(data?.publishingYear?.min);
      setAllowedMinPublishingYear(data?.publishingYear?.min);
    });
  }, []);

  const searchQuery = location.state?.query;

  useEffect(() => {
    fetchPageData().then(() => {
      history.replace(location.pathname, {});
    });
  }, [
    selectedGenres,
    minPublishingYear,
    maxPublishingYear,
    sortBy,
    currentPage,
    searchQuery
  ]);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
      setIsPageChange(true);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
      setIsPageChange(true);
    }
  };

  const crumbs = [
    { title: "Home", path: "/" },
    { title: "Best Sellers", path: urls.BESTSELLER },
  ];

  const isWishListItem = (bookData) => {
    const bookOpt = wishlist?.find((item) => item?.book?.sku === bookData.sku && item?.book?.title === bookData?.title)
    if(bookOpt) {
      return {isPresent : true, data: bookOpt}
    } else {
      return {isPresent : false, data:null}
    }
  }

  const bgImage = "/Assets/Images/Banners/BestSellerBanner.png"

  return (
    <div className={classes.mainContainer} ref={scrollRef}>
      <SEO 
        keywords="Bestseller books"
        title="Top Bestseller Books List 2024, Shop Cheap Books Online"
        description="Explore the hottest reads of 2024! Dive into captivating stories and discover new worlds with Rare Biblio's Top Bestseller Books List. Start your adventure now!"
       canonicalUrl={"https://www.rarebiblio.com/best-seller-book"}
       structuredData={{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Best Seller Book",
        "description": "Explore our curated collection of the best-selling books, including vintage, antique, and personalized editions for book enthusiasts.",
        "url": "https://rarebiblio.com/best-seller-book",
        "publisher": {
          "@type": "Organization",
          "name": "Rare Biblio",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
          }
        },
        "mainEntityOfPage": "https://rarebiblio.com/best-seller-book",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://rarebiblio.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Best Seller Book",
              "item": "https://rarebiblio.com/best-seller-book"
            }
          ]
        },
        "sameAs": [
          "https://www.facebook.com/rarebiblio/",
          "https://www.instagram.com/Rarebiblio/",
          "https://www.linkedin.com/company/Rarebiblio",
          "https://in.pinterest.com/rare_biblio/",
          "https://x.com/Rarebiblio"
        ]
      }}
        />
      <PrimaryNav />
      <BannerHeader crumbs={crumbs} title={"Bestseller books"} bgImage={bgImage}/>
      <div className={classes.nav}>
        <div className={classes.SearchComponent}>
          <SearchComponent
            query={query}
            onChange={(e) => setQuery(e.target.value)}
            onSearch={() => {
              fetchPageData();
              setCurrentPage(1);
            }}
            setQuery={setQuery}
            minYear={minPublishingYear}
            maxYear={maxPublishingYear}
            selectedGenres={selectedGenres}
            allowedMaxPublishingYear={allowedMaxPublishingYear}
            allowedMinPublishingYear={allowedMinPublishingYear}
            searchCriteria={searchCriteria}
            setSearchCriteria={setSearchCriteria}
          />
        </div>
      </div>

      <div className={classes.mainSection}>
        <div className={classes.sidebar}>
          <Sidebar
            allGenres={allGenres}
            selectedGenres={selectedGenres}
            setSelectedGenres={setSelectedGenres}
            allowedMaxYear={allowedMaxPublishingYear}
            allowedMinYear={allowedMinPublishingYear}
            maxYear={maxPublishingYear}
            minYear={minPublishingYear}
            setMaxYear={setMaxPublishingYear}
            setMinYear={setMinPublishingYear}
          />
        </div>
        <div className={classes.content}>
          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
               <div className={classes.sortByContainer} style={{ display: "flex", alignItems: "center" ,justifyContent:"flex-end"}}>
            <div className={classes.sortBtn}>
              <select
                name="sortBy"
                id="sortBy"
                value={sortBy || ""}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="" disabled>
                  Sort By
                </option>
                <option value="title ASC">A-Z</option>
                <option value="title DESC">Z-A</option>
                <option value="lastUpdated ASC">Sort by Date: Newest</option>
                <option value="lastUpdated DESC">Sort by Date: Oldest</option>
                <option value="priceGenuine DESC">Price: High-Low</option>
                <option value="priceGenuine ASC">Price: Low-High</option>
              </select>
            </div>
          </div>
              <p className={classes.searchCount}>
                Showing {totalResults} results
              </p>
              <div className={classes.cardGrid}>
                {searchResults.map((card, index) => (
                  <Card
                    key={index}
                    image={card.imageUrl}
                    title={card.title}
                    author={card.author}
                    price={sortBy?.split(" ")?.[0] === "priceVegan" ? card?.priceVegan : card?.priceGenuine}
                    altText={
                      getRandomImageForBestSellerBook(card, allColorsData)
                        ?.altText
                    }
                    bookData={card}
                    isWishListItem = {isWishListItem(card).isPresent}
                    wishlistItemId = {isWishListItem(card)?.data?.id}
                  />
                ))}
              </div>

              {/* Pagination Controls */}
              <div className={classes.paginationControls}>
                <div className={classes.paginatonBtn}>
                  <FontAwesomeIcon icon={faArrowLeft} onClick={handlePrevPage} className={classes.arrowLeft}/>
                  <button onClick={handlePrevPage} disabled={currentPage === 1}>
                    Prev
                  </button>
                </div>

                <span>
                  {currentPage > 2 && (
                    <a
                      onClick={() => {
                        setCurrentPage(1);
                        setIsPageChange(true);
                      }}
                    >
                      1
                    </a>
                  )}
                  {currentPage > 3 && <span className={classes.dots}>...</span>}
                  {currentPage > 1 && (
                    <a
                      onClick={() => {
                        setCurrentPage(currentPage - 1);
                        setIsPageChange(true);
                      }}
                    >
                      {currentPage - 1}
                    </a>
                  )}
                  <span className={`${classes.pageNumber} ${classes.active}`}>
                    {currentPage}
                  </span>
                  {currentPage < totalPages && (
                    <a
                      onClick={() => {
                        setCurrentPage(currentPage + 1);
                        setIsPageChange(true);
                      }}
                    >
                      {currentPage + 1}
                    </a>
                  )}
                  {currentPage < totalPages - 2 && (
                    <span className={classes.dots}>...</span>
                  )}
                  {currentPage < totalPages - 1 && (
                    <a
                      onClick={() => {
                        setCurrentPage(totalPages);
                        setIsPageChange(true);
                      }}
                    >
                      {totalPages}
                    </a>
                  )}
                </span>

                <div className={classes.paginatonBtn}>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                  <FontAwesomeIcon icon={faArrowRight} onClick={handleNextPage} className={classes.arrowRight}/>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BestSeller;
